import { useEffect } from 'react';

const SUFFIX = 'Autistic Dev';

const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title ? `${title} · ${SUFFIX}` : `${SUFFIX} — Different wiring. Brilliant software.`;
  }, [title]);
};

export default usePageTitle;
